import { useEffect } from 'react';

import useMediaLibrarySettings from '~modules/media-library/context/useMediaLibrarySettings';
import useMediaLibraryUserPreferences from '~modules/media-library/context/useMediaLibraryUserPreferences';
import { ViewContext } from '~modules/media-library/model/ViewContext';
import { FilterBar } from '~modules/media-library/view/FilterBar/FilterBar';
import { Header } from '~modules/media-library/view/Header/Header';
import { TagBar } from '~modules/media-library/view/TagBar/TagBar';

export default function MediaLibraryHeaderController() {
  const { filterList } = useMediaLibrarySettings();
  const { activeFilterIds, selectedFilterValueIds, onSetActiveFilterIds, onSetSelectedFilterValueIds } =
    useMediaLibraryUserPreferences();

  const { setViewContext } = useMediaLibrarySettings();

  useEffect(() => {
    setViewContext(ViewContext.SEARCH);
  });

  return (
    <Header>
      <FilterBar
        filterList={filterList}
        activeFilterIds={activeFilterIds}
        selectedFilterValueIds={selectedFilterValueIds}
        onChangeSelectedFilterValueIds={onSetSelectedFilterValueIds}
        onChangeActiveFilterIds={onSetActiveFilterIds}
      />
      <TagBar
        filterList={filterList}
        selectedFilterValueIds={selectedFilterValueIds}
        onChangeSelectedFilterValueIds={onSetSelectedFilterValueIds}
      />
    </Header>
  );
}
